import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const normalizePeriodo = (periodo) => String(periodo || '').replace(/\D/g, '')
const extractYear = (periodo) => {
  const normalized = normalizePeriodo(periodo)
  const match = normalized.match(/^\d{4}/)
  return match ? match[0] : ''
}

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    _language: navigator.language,
    token: null,
    userName: null,
    userRole: null,
    companyId: null,
    expiration: 0,
    isAuthenticated: false,
    componentControls: {
      'BalanceNiif': {
        'Notas': true,
        'Balance': true,
        'Comparativo': true,
        'Consolidado': true,
        'Informacion': true
      },
    },
    periodos: {
      // Se almacenan vigencias exactas.
      // Ejemplo: '202601': false, '202603': true
    }
    
  },
  mutations: {
    setData(state, val){
        state.token = val.token
        state.userName = val.username
        state.providerId = val.inscriptionId
        state.userRole = val.role
        const now = new Date();
        const expirationDate = new Date(now.getTime() + val.expiresIn * 1000);
        state.userId = val.id
        state.expiration = expirationDate
        state.isAuthenticated = val.isAuthenticated
        state.companyId = val.companyId
    },

    setLang(state, val){
        state._language = val
    },

    updateComponentControl(state, { componentName, controlName, isVisible }) {

      if (!state.componentControls[componentName]) {
        state.componentControls[componentName] = {}
      }
      Vue.set(state.componentControls[componentName], controlName, isVisible)
    },

    setComponentControls(state, { componentName, controls }) {
      state.componentControls[componentName] = controls
    },

    // Mutación para habilitar/deshabilitar una vigencia específica
    togglePeriodo(state, { periodo, enabled }) {
      if (!state.periodos) {
        state.periodos = {}
      }
      const normalizedPeriodo = normalizePeriodo(periodo)
      if (!normalizedPeriodo) return
      Vue.set(state.periodos, normalizedPeriodo, enabled)
    },
    
    // Mutación para establecer múltiples períodos de una vez
    setPeriodos(state, periodos) {
      state.periodos = periodos
    },
    
    // Mutación para inicializar vigencias desde la base de datos
    initializePeriodos(state, periodosDisponibles) {
      if (!state.periodos) {
        state.periodos = {}
      }
      periodosDisponibles.forEach(periodo => {
        const normalizedPeriodo = normalizePeriodo(periodo)
        if (!normalizedPeriodo) return
        if (state.periodos[normalizedPeriodo] === undefined) {
          Vue.set(state.periodos, normalizedPeriodo, true)
        }
      })
    }
},

  getters: {
    getComponentControls: (state) => (componentName) => {
      return state.componentControls[componentName] || {}
    },
    isControlVisible: (state) => (componentName, controlName) => {
      const component = state.componentControls[componentName]
      if (!component) return true
      return component[controlName] !== false
    },
    getAllPeriodos: (state) => {
      return state.periodos || {}
    },
    isPeriodoEnabled: (state) => (periodo) => {
      if (!periodo) return true

      const normalizedPeriodo = normalizePeriodo(periodo)
      const year = extractYear(normalizedPeriodo)
      const periodos = state.periodos || {}

      if (periodos[normalizedPeriodo] !== undefined) {
        return periodos[normalizedPeriodo] !== false
      }

      // Compatibilidad con configuraciones antiguas guardadas por año.
      if (periodos[year] !== undefined) {
        return periodos[year] !== false
      }

      return true
    },
    
  }
})

export default store
